var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9958 0.999512H9.99666C9.4446 0.999512 8.99707 1.44704 8.99707 1.9991V15.9933C8.99707 16.5454 9.4446 16.9929 9.99666 16.9929H11.9958C12.5479 16.9929 12.9954 16.5454 12.9954 15.9933V1.9991C12.9954 1.44704 12.5479 0.999512 11.9958 0.999512Z",
    strokeWidth: 1.99918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99876 0.999512H1.99959C1.44753 0.999512 1 1.44704 1 1.9991V15.9933C1 16.5454 1.44753 16.9929 1.99959 16.9929H3.99876C4.55082 16.9929 4.99835 16.5454 4.99835 15.9933V1.9991C4.99835 1.44704 4.55082 0.999512 3.99876 0.999512Z",
    strokeWidth: 1.99918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseNew);
export default __webpack_public_path__ + "static/media/pause_new.ee3f03c5aecd63dbc2afa27f411f0d6f.svg";
export { ForwardRef as ReactComponent };